import * as React from "react"
import Title from "../components/Title" 
import Video from "../components/video" 

class Specialties extends React.Component {
  render() {
    return (
    	<>
    		<div className="video-tiles max-1600 p30 flex ma fade-in m-mt0 m-pt0" data-scroll data-scroll-offset="500">
    			<div className="w-33 m-hide">
    				<div className="ratio-3-1 pos-rel" style={{'background':'#b38279'}}>
    					<Video video={this.props.video1}  />
    				</div> 
    			</div>
    			<div className="w-33 mw-100 mln1">
    				<div className="ratio-3-1 pos-rel" style={{'background':'#b38279'}}>
    					<Video video={this.props.video2} image={this.props.image.gatsbyImageData}  />
    				</div>
    			</div>
    			<div className="w-33 m-hide mln1"> 
    				<div className="ratio-3-1 pos-rel" style={{'background':'#b38279'}}>
    					<Video video={this.props.video3}  />
    				</div>
    			</div>
    		</div>
        
        <div className="spacer m-spacer"></div>

        <div className="p30 text-center strong fade-in m-pt0" data-scroll data-scroll-offset="300">
          Specialising in
        </div>
        <Title Line1="Weddings" Line2="Events &" Line3="Experiential" Line4="Florals" scroll="true" heading="small h1"/> 
        
        <div className="spacer m-spacer m-mb30"></div>

      </>
    )
  }
} 

export default Specialties

